import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { completeMagicLinkSignIn } from "../services/authService";

const MagicLinkHandler = ({ setUser, setRole }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkMagicLink = async () => {
      const result = await completeMagicLinkSignIn();

      if (result?.success) {
        setUser(result.user);
        setRole(result.role);
        navigate("/"); // ✅ Zur Startseite weiterleiten
      } else if (result?.error) {
        console.error("Fehler beim Magic Link Login:", result.error);
      }
    };

    checkMagicLink();
  }, [navigate, setUser, setRole]);

  return <h1>Magic-Link Anmeldung wird verarbeitet...</h1>;
};

export default MagicLinkHandler;
